const kenBurnsEffectClassMap = [
    {
        name: 'Center Short',
        in: 'animate-kenburns-center-in-short',
        out: 'animate-kenburns-center-out'
    },
    {
        name: 'Center Long',
        in: 'animate-kenburns-center-in-long',
        out: 'animate-kenburns-center-out'
    },
    {
        name: 'Top Short',
        in: 'animate-kenburns-top-in-short',
        out: 'animate-kenburns-top-out'
    },
    {
        name: 'Top Long',
        in: 'animate-kenburns-top-in-long',
        out: 'animate-kenburns-top-out'
    },
    {
        name: 'Bottom Short',
        in: 'animate-kenburns-bottom-in-short',
        out: 'animate-kenburns-bottom-out'
    },
    {
        name: 'Bottom Long',
        in: 'animate-kenburns-bottom-in-long',
        out: 'animate-kenburns-bottom-out'
    },
    {
        name: 'Left Short',
        in: 'animate-kenburns-left-in-short',
        out: 'animate-kenburns-left-out'
    },
    {
        name: 'Left Long',
        in: 'animate-kenburns-left-in-long',
        out: 'animate-kenburns-left-out'
    },
    {
        name: 'Right Short',
        in: 'animate-kenburns-right-in-short',
        out: 'animate-kenburns-right-out'
    },
    {
        name: 'Right Long',
        in: 'animate-kenburns-right-in-long',
        out: 'animate-kenburns-right-out'
    },
    {
        name: 'Top Left Short',
        in: 'animate-kenburns-top-left-in-short',
        out: 'animate-kenburns-top-left-out'
    },
    {
        name: 'Top Left Long',
        in: 'animate-kenburns-top-left-in-long',
        out: 'animate-kenburns-top-left-out'
    },
    {
        name: 'Top Right Short',
        in: 'animate-kenburns-top-right-in-short',
        out: 'animate-kenburns-top-right-out'
    },
    {
        name: 'Top Right Long',
        in: 'animate-kenburns-top-right-in-long',
        out: 'animate-kenburns-top-right-out'
    },
    {
        name: 'Bottom Left Short',
        in: 'animate-kenburns-bottom-left-in-short',
        out: 'animate-kenburns-bottom-left-out'
    },
    {
        name: 'Bottom Left Long',
        in: 'animate-kenburns-bottom-left-in-long',
        out: 'animate-kenburns-bottom-left-out'
    },
    {
        name: 'Bottom Right Short',
        in: 'animate-kenburns-bottom-right-in-short',
        out: 'animate-kenburns-bottom-right-out'
    },
    {
        name: 'Bottom Right Long',
        in: 'animate-kenburns-bottom-right-in-long',
        out: 'animate-kenburns-bottom-right-out'
    }
];
export { kenBurnsEffectClassMap };
